import {
  createPlugin,
  createRoutableExtension,
  createApiFactory,
  createExternalRouteRef,
  discoveryApiRef,
  fetchApiRef,
} from '@backstage/core-plugin-api';
import { rootRouteRef } from './routes';
import { agentRegistryApiRef } from './api/AgentRegistryApi';
import { AgentRegistryClient } from './api/AgentRegistryClient';

/** External route refs — resolved at app-level via bindRoutes */
export const toolsRegistryExternalRouteRef = createExternalRouteRef({
  id: 'tools-registry',
});

export const workflowComposerExternalRouteRef = createExternalRouteRef({
  id: 'workflow-composer',
});

export const agentRegistryPlugin = createPlugin({
  id: 'agent-registry',
  routes: {
    root: rootRouteRef,
  },
  externalRoutes: {
    toolsRegistry: toolsRegistryExternalRouteRef,
    workflowComposer: workflowComposerExternalRouteRef,
  },
  apis: [
    createApiFactory({
      api: agentRegistryApiRef,
      deps: {
        discoveryApi: discoveryApiRef,
        fetchApi: fetchApiRef,
      },
      factory: ({ discoveryApi, fetchApi }) =>
        new AgentRegistryClient({ discoveryApi, fetchApi }),
    }),
  ],
});

export const AgentRegistryPage = agentRegistryPlugin.provide(
  createRoutableExtension({
    name: 'AgentRegistryPage',
    component: () =>
      import('./components/AgentRegistryPage').then(m => m.AgentRegistryPage),
    mountPoint: rootRouteRef,
  }),
);
